import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router";
import './customNavigateButton.scss'

const NavigateBackButton = ({
  label,
  navigateLink,
  state,
  options,
}: {
  label: string;
  navigateLink: string;
  state?: object;
  options?: object;
}) => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate(navigateLink,{
      state: state?state:{},
      ...(options || {})
    });
  };
  return (
    <Box display={"flex"} minHeight={"50px"} className="navigateBox">
      <Button onClick={handleNavigation} sx={{ color: "primary.main" }}>
        <KeyboardBackspaceIcon sx={{ mr: 1 }} />
        <Typography variant="body1">{label}</Typography>
      </Button>
    </Box>
  );
};

export default NavigateBackButton;
